import { useTheme } from '@emotion/react';
import DeleteIcon from '@mui/icons-material/Delete';
import FilterListIcon from '@mui/icons-material/FilterList';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import IconButton from '@mui/material/IconButton';
import LinearProgress, {
  linearProgressClasses,
} from '@mui/material/LinearProgress';
import Paper from '@mui/material/Paper';
import { alpha, styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Toolbar from '@mui/material/Toolbar';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { makeStyles } from '@mui/styles';
import Avatar from 'antd/es/avatar/avatar';
import Dp from 'assets/dummy/buy.jpg';
import PropTypes from 'prop-types';
import * as React from 'react';
import { useEffect, useState } from 'react';
import { poppins400, poppins500 } from 'theme/common.style';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import { Grid } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import dayjs from 'dayjs';
import { useMediaQuery } from '@mui/material';
import {
  displayFlex,
  imageCont,
  userDetCont,
} from 'component/ActivityContainer/ActivityContainer.style';
import { OfferContainer } from './BuyerRegistration.util';
import BadgeButton from './components/BadgeButton';

function EnhancedTableHead(props) {
  const {
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onRequestSort,
    headCells,
    buyeroffer,
    tableData,
    tableChecked,
    setTableChecked,
    propertyDetails,
    forwardBuyersOfferToOtherBuyersui,
    tableCheckedpopup,
    setTableCheckedpopup,
    setForwardBuyerCheckList,
    forwardBuyerCheckList,
    selectedrowbuyeridfilter,
    forwardtobuyer,
    expandedRows,
    currentUserIsFwdToBuyer,
    setForwardUsernameCheckList,
    setForwardSurUsernameCheckList,
  } = props;

  useEffect(() => {
    if (!forwardtobuyer) {
      setTableCheckedpopup(false);
      setForwardBuyerCheckList([]);
      setForwardUsernameCheckList([]);
      setForwardSurUsernameCheckList([]);
    }
  }, [forwardtobuyer]);

  const handleSelectAllClick = () => {
    const isChecked = !tableCheckedpopup;
    setTableCheckedpopup(isChecked);

    if (isChecked) {
      const selectedUsers = tableData
        .filter(
          (row) =>
            row?.buyerDetails?.user?.userId !== selectedrowbuyeridfilter &&
            !currentUserIsFwdToBuyer.includes(row?.buyerDetails?.user?.userId)
        )
        .map((row) => {
          const userId = row?.buyerDetails?.user?.userId || '';
          const userName = row?.buyerDetails?.user?.userName || '';
          const userSurName = row?.buyerDetails?.user?.userSurName || '';
          return { userId, userName, userSurName };
        });

      setForwardBuyerCheckList(selectedUsers.map((user) => user.userId));
      setForwardUsernameCheckList(selectedUsers.map((user) => user.userName));
      setForwardSurUsernameCheckList(
        selectedUsers.map((user) => user.userSurName)
      );
    } else {
      setForwardBuyerCheckList([]);
      setForwardUsernameCheckList([]);
      setForwardSurUsernameCheckList([]);
    }
  };

  return (
    <TableHead sx={{ width: '100%' }}>
      <TableRow sx={{ width: '100%' }}>
        <TableCell padding="checkbox" sx={{ width: '0.5%' }}>
          <Typography style={{ paddingLeft: '20px' }}>
            <input
              checked={tableCheckedpopup}
              onClick={handleSelectAllClick}
              padding="checkbox"
              type="checkbox"
            />
          </Typography>
        </TableCell>

        <TableCell
          sx={{
            fontSize: '10px',
            fontWeight: 400,
            fontFamily: 'poppins',
            textAlign: 'center',
          }}
        >
          Name
        </TableCell>

        <TableCell
          sx={{
            fontSize: '10px',
            fontWeight: 400,
            fontFamily: 'poppins',
            textAlign: 'center',
            whiteSpace: 'nowrap',
            width: '25%',
          }}
        >
          Buyer Readiness
        </TableCell>

        <TableCell
          sx={{
            fontSize: '10px',
            fontWeight: 400,
            fontFamily: 'poppins',
            textAlign: 'center',
          }}
        >
          Offer
        </TableCell>
        <TableCell
          sx={{
            fontSize: '10px',
            fontWeight: 400,
            fontFamily: 'poppins',
            textAlign: 'center',
            whiteSpace: 'nowrap',
          }}
        >
          #Offers
        </TableCell>
        <TableCell
          sx={{
            fontSize: '10px',
            fontWeight: 400,
            fontFamily: 'poppins',
            textAlign: 'center',
            width: '10%',
            whiteSpace: 'nowrap',
          }}
        >
          Ratings
        </TableCell>
        <TableCell
          sx={{
            fontSize: '10px',
            fontWeight: 400,
            fontFamily: 'poppins',
            textAlign: 'left',
          }}
        >
          Status
        </TableCell>
        <TableCell
          sx={{
            fontSize: '10px',
            fontWeight: 400,
            fontFamily: 'poppins',
            textAlign: 'left',
          }}
        >
          Shared
        </TableCell>
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
  headCells: PropTypes.array.isRequired,
  setForwardBuyerCheckList: PropTypes.func.isRequired,
  selectedrowbuyeridfilter: PropTypes.string.isRequired,
};

function EnhancedTableToolbar(props) {
  const { numSelected } = props;
  return (
    <Toolbar
      sx={{
        pl: { sm: 2 },
        pr: { xs: 1, sm: 1 },
        ...(numSelected > 0 && {
          bgcolor: (theme) =>
            alpha(
              theme.palette.primary.main,
              theme.palette.action.activatedOpacity
            ),
        }),
      }}
    >
      {numSelected > 0 ? (
        <Typography
          sx={{ flex: '1 1 100%' }}
          color="inherit"
          variant="subtitle1"
          component="div"
        >
          {numSelected} selected
        </Typography>
      ) : (
        <Typography
          sx={{ flex: '1 1 100%' }}
          variant="h6"
          id="tableTitle"
          component="div"
        ></Typography>
      )}

      {numSelected > 0 ? (
        <Tooltip title="Delete">
          <IconButton>
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      ) : (
        <Tooltip title="Filter list">
          <IconButton>
            <FilterListIcon />
          </IconButton>
        </Tooltip>
      )}
    </Toolbar>
  );
}

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

export const collectId = (
  tableData,
  id,
  setBuyerId,
  setPosition,
  setArrayCollection
) => {
  let arrayCollection = [];
  if (tableData?.length > 0) {
    for (let index = 0; index < tableData?.length; index++) {
      const element = tableData[index]?.buyerDetails?.user?.userId;
      arrayCollection.push(element);
    }
    setArrayCollection(arrayCollection);
    setBuyerId(id);

    let position = arrayCollection.indexOf(id);
    setPosition(position);
  }
};
export default function EnhancedforwardTable(props) {
  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const {
    getListInfo,
    onShowChat,
    vendorPropertyId,
    propertyDetails,
    stage,
    propertyidVendor,
    propertyId,
    forwardtootherbuyerstatus,
    selectedrowbuyeridfilter,
    publishwinner,
    forwardBuyersOfferToOtherBuyersui,
    setSelbuyerId,
    buyerpropertylist,
    forwardBuyerCheckList,
    setForwardBuyerCheckList,
    forwardUsernameList,
    setForwardUsernameCheckList,
    forwardSurUsernameList,
    setForwardSurUsernameCheckList,
  } = props;
  const [showModal, setShowModal] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [row, setRow] = React.useState({});
  const [position, setPosition] = useState(0);
  const [arrayCollection, setArrayCollection] = useState([]);
  const [openOwner, setOpenOwner] = useState(false);
  const [counterOfferDialog, setCounterOfferDialog] = React.useState(false);
  const [itemObj, setItemObj] = useState({});
  const [forwardtootherbuyer, setForwardtootherbuyer] = useState(false);
  const [vendorAction, setVendorAction] = useState('');
  const [errorMessage, setErrorMessage] = useState({
    helperText: '',
    error: false,
  });
  const [vendorOffer, setVendorOffer] = useState(0);
  const handleKeyPress = (event) => {
    if (event.key === 'e' || event.key === 'E' || event.key === '-') {
      event.preventDefault();
    }
  };
  const useStyles = makeStyles({
    noSpinArrows: {
      '& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button':
        {
          '-webkit-appearance': 'none',
          margin: 0,
        },
    },
  });
  const classes = useStyles();

  const handlePress = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleMenuItemClick = (itemId) => {
    if (itemId === 1) {
      setShowModal(true);
    } else {
    }
  };
  const {
    headCells,
    tableData,
    buyeroffer,
    address,
    setForwardOfferCheckList,
    forwardOfferCheckList,
    days,
    hours,
    minutes,
    seconds,
    tableChecked,
    setTableChecked,
    tableCheckedpopup,
    setTableCheckedpopup,
    tableCheckedpopupui,
    setTableCheckedpopupui,
    forwardtobuyer,
  } = props;

  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState('');
  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [sortedTableData, setSortedTableData] = useState([]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelected = tableData.map((n) => n.name);
      setSelected(newSelected);
      return;
    }
    setSelected([]);
  };

  useEffect(() => {
    setSortedTableData(tableData);
  }, [tableData]);

  const isSelected = (name) => selected.indexOf(name) !== -1;

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - tableData.length) : 0;

  React.useEffect(() => {
    setArrayCollection(arrayCollection);
  }, [arrayCollection]);
  function CircularProgressWithLabel(props) {
    return (
      <Box sx={{ position: 'relative', display: 'inline-flex' }}>
        <CircularProgress
          variant="determinate"
          value={(props.value / 10) * 100}
          sx={{ color: '#10D35E' }}
          thickness={5}
          size={45}
        />
        <Box
          sx={{
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            position: 'absolute',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Typography
            variant="caption"
            component="div"
            sx={{ color: '#000000', ...poppins500, fontSize: '14px' }}
          >
            {props.rating}
          </Typography>
        </Box>
      </Box>
    );
  }
  function CircularProgressWithProfile(props) {
    return (
      <Box sx={{ position: 'relative', display: 'inline-flex' }}>
        <CircularProgress
          variant="determinate"
          value={100}
          sx={{ color: '#C4C4C461' }}
          thickness={5}
          size={45}
        />
        <CircularProgress
          variant="determinate"
          value={props.value}
          sx={{ color: '#10D35E', position: 'absolute' }}
          thickness={5}
          size={45}
        />
        <Box
          sx={{
            top: '50%',
            left: '53%',
            transform: 'translate(-50%, -50%)',
            position: 'absolute',
          }}
        >
          <Typography
            variant="caption"
            component="div"
            sx={{ color: '#000000', ...poppins500, fontSize: '14px' }}
          >
            {props.profileImage == '' || props.profileImage == null ? (
              <Avatar
                style={{
                  width: '36px',
                  height: '36px',
                  fontStyle: 'poppins',
                  backgroundColor: '#666666',
                }}
              >
                {props.name}
              </Avatar>
            ) : (
              <Avatar
                alt="Remy"
                src={props.profileImage}
                style={{
                  width: '36px',
                  height: '36px',
                }}
              />
            )}
          </Typography>
        </Box>
      </Box>
    );
  }
  function CircularProgressWithProfileVendor(props) {
    return (
      <Box sx={{ position: 'relative', display: 'inline-flex' }}>
        <CircularProgress
          variant="determinate"
          value={100}
          sx={{ color: '#C4C4C461' }}
          thickness={5}
          size={45}
        />
        <CircularProgress
          variant="determinate"
          value={props.value * 10}
          sx={{ color: '#10D35E', position: 'absolute' }}
          thickness={5}
          size={45}
        />
        <Box
          sx={{
            top: '50%',
            left: '53%',
            transform: 'translate(-50%, -50%)',
            position: 'absolute',
          }}
        >
          <Typography
            variant="caption"
            component="div"
            sx={{ color: '#000000', ...poppins500, fontSize: '14px' }}
          >
            <Avatar
              alt="Remy"
              src={Dp}
              style={{
                width: '36px',
                height: '36px',
              }}
            />
          </Typography>
        </Box>
      </Box>
    );
  }

  const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 16,
    position: 'relative',
    [`&.${linearProgressClasses.colorPrimary}`]: {
      background: '#FFFFFF',
      border: '0.81px solid',
      borderRadius: 2.42,
      borderColor: '#6C2AD2',
    },
    [`& .${linearProgressClasses.bar}`]: {
      background:
        'linear-gradient(140.46deg, #6C2AD2 -27.13%, #77CFFE 121.57%)',
      borderRadius: 2.42,
      transition: 'none',
    },
  }));
  const TextOverlay = styled(Typography)(({ theme, leftPosition }) => ({
    position: 'absolute',
    top: '50%',
    left: `${leftPosition}%`,
    transform: 'translate(-50%, -50%)',
    zIndex: 1,
    fontSize: '10px',
    fontFamily: 'Poppins',
    color: '#FFFFFF',
    fontWeight: '400px',
    alignItems: 'center',
  }));

  function LinearProgressBarWithPercentage(props) {
    const rediness = props.rediness || 0;
    return (
      <div style={{ position: 'relative' }}>
        <BorderLinearProgress variant="determinate" value={props.value} />
        <TextOverlay
          sx={{ color: 'white', textShadow: '-1px 1px 0px black' }}
          variant="body2"
          color="textSecondary"
          leftPosition={'50%'}
        >
          {`${Math.round(props.value)}%`}
        </TextOverlay>
      </div>
    );
  }

  const [expandedRows, setExpandedRows] = useState({});

  const handleIconClick = (index) => {
    setExpandedRows((prevExpandedRows) => ({
      ...prevExpandedRows,
      [index]: !prevExpandedRows[index],
    }));
  };
  const currentUserId = selectedrowbuyeridfilter;
  const currentUserData = sortedTableData.find(
    (data) => data?.buyerDetails?.user?.userId == currentUserId
  );
  const currentUserIsFwdToBuyer =
    currentUserData?.buyerOfferDetails?.isFwdToBuyer || [];

  return (
    <>
      <Box sx={{ width: '100%' }}>
        <Paper
          sx={{
            width: '100%',
            mb: 2,
            boxShadow: 'none',
            border: '1px solid #F0F0F0',
            borderRadius: '5px',
          }}
        >
          <TableContainer
            sx={{
              overflow: 'scroll',
              maxHeight: 'none',
              '&::-webkit-scrollbar': {
                width: 0,
                height: 0,
              },
              '&': {
                scrollbarWidth: 'none',
                msOverflowStyle: 'none',
              },
            }}
          >
            <Table
              sx={{
                maxWidth: buyeroffer && '540px',
              }}
              aria-labelledby="tableTitle"
              size="medium"
            >
              <EnhancedTableHead
                buyeroffer={buyeroffer}
                headCells={headCells}
                numSelected={selected.length}
                order={order}
                orderBy={orderBy}
                setOrderBy={setOrderBy}
                setOrder={setOrder}
                onSelectAllClick={handleSelectAllClick}
                onRequestSort={handleRequestSort}
                rowCount={tableData?.length}
                tableData={tableData}
                setForwardBuyerCheckList={props.setForwardBuyerCheckList}
                forwardBuyerCheckList={forwardBuyerCheckList}
                setTableCheckedpopup={setTableCheckedpopup}
                tableCheckedpopup={tableCheckedpopup}
                propertyDetails={propertyDetails}
                selectedrowbuyeridfilter={selectedrowbuyeridfilter}
                forwardtobuyer={forwardtobuyer}
                expandedRows={expandedRows}
                currentUserIsFwdToBuyer={currentUserIsFwdToBuyer}
                forwardUsernameList={forwardUsernameList}
                setForwardUsernameCheckList={setForwardUsernameCheckList}
                forwardSurUsernameList={forwardSurUsernameList}
                setForwardSurUsernameCheckList={setForwardSurUsernameCheckList}
              />
              <TableBody sx={{ width: '100%' }}>
                {sortedTableData &&
                Array.isArray(sortedTableData) &&
                sortedTableData.length > 0 ? (
                  sortedTableData.map((row, index) => {
                    const buyerId = row?.buyerDetails?.user?.userId;
                    const labelId = `enhanced-table-checkbox-${index}`;
                    const isDisabled =
                      currentUserIsFwdToBuyer.includes(buyerId);
                    let offerHistory = [];
                    const matchingRow = sortedTableData.find(
                      (r) =>
                        r?.buyerDetails?.user?.userId ==
                        selectedrowbuyeridfilter
                    );
                    if (
                      matchingRow &&
                      matchingRow?.buyerOfferDetails?.offerForwardedHistory
                    ) {
                      if (isDisabled) {
                        offerHistory =
                          matchingRow?.buyerOfferDetails
                            ?.offerForwardedHistory || [];
                      } else {
                        offerHistory =
                          matchingRow?.buyerOfferDetails
                            ?.offerForwardedHistory || [];
                      }
                    }

                    let forwardedAt = '-';

                    if (offerHistory.length > 0) {
                      const matchedEntry = offerHistory.find(
                        (entry) => entry.buyerId == buyerId
                      );
                      if (matchedEntry) {
                        forwardedAt = dayjs(matchedEntry?.forwardedAt).format(
                          'HH:mm:ss DD-MM-YYYY'
                        );
                      }
                    }

                    if (buyerId !== selectedrowbuyeridfilter) {
                      return (
                        <TableRow
                          sx={{
                            width: '100%',
                            cursor: matchessm ? 'pointer' : 'default',
                          }}
                          style={{
                            pointerEvents: isDisabled && 'none',
                            opacity: isDisabled && 0.5,
                            backgroundColor: isDisabled && '#f0f0f0',
                          }}
                          hover
                          role="checkbox"
                          tabIndex={-1}
                          key={row.name}
                          onClick={() => {
                            if (matchessm) {
                              const updatedList =
                                forwardBuyerCheckList.includes(buyerId)
                                  ? forwardBuyerCheckList.filter(
                                      (id) => id !== buyerId
                                    )
                                  : [...forwardBuyerCheckList, buyerId];
                              setForwardBuyerCheckList(updatedList);
                              const allChecked = tableData
                                .filter(
                                  (row) =>
                                    row?.buyerDetails?.user?.userId !==
                                    selectedrowbuyeridfilter
                                )
                                .every((row) =>
                                  updatedList.includes(
                                    row?.buyerDetails?.user?.userId || ''
                                  )
                                );
                              setTableCheckedpopup(allChecked);
                            }
                          }}
                        >
                          <TableCell padding="checkbox" sx={{ width: '0.5%' }}>
                            <Typography style={{ paddingLeft: '20px' }}>
                              <input
                                type="checkbox"
                                color="primary"
                                checked={forwardBuyerCheckList.includes(
                                  buyerId
                                )}
                                inputProps={{
                                  'aria-labelledby': labelId,
                                }}
                                disabled={isDisabled}
                                onChange={() => {
                                  const userName =
                                    row?.buyerDetails?.user?.userName;
                                  const userSurName =
                                    row?.buyerDetails?.user?.userSurName;
                                  const updatedList =
                                    forwardBuyerCheckList.includes(buyerId)
                                      ? forwardBuyerCheckList.filter(
                                          (id) => id !== buyerId
                                        )
                                      : [...forwardBuyerCheckList, buyerId];
                                  setForwardBuyerCheckList(updatedList);

                                  const updatedUsernameList =
                                    updatedList.includes(buyerId)
                                      ? [...forwardUsernameList, userName]
                                      : forwardUsernameList.filter(
                                          (name) => name !== userName
                                        );

                                  setForwardUsernameCheckList(
                                    updatedUsernameList
                                  );

                                  const updatedSurUsernameList =
                                    updatedList.includes(buyerId)
                                      ? [...forwardSurUsernameList, userSurName]
                                      : forwardSurUsernameList.filter(
                                          (surname) => surname !== userSurName
                                        );

                                  setForwardSurUsernameCheckList(
                                    updatedSurUsernameList
                                  );

                                  const allChecked = tableData
                                    .filter(
                                      (row) =>
                                        row?.buyerDetails?.user?.userId !==
                                        selectedrowbuyeridfilter
                                    )
                                    .every((row) =>
                                      updatedList.includes(
                                        row?.buyerDetails?.user?.userId || ''
                                      )
                                    );
                                  setTableCheckedpopup(allChecked);
                                }}
                              />
                            </Typography>
                          </TableCell>

                          <TableCell
                            component="th"
                            id={labelId}
                            scope="row"
                            padding="none"
                            sx={{ width: '7%' }}
                          >
                            <Typography sx={userDetCont}>
                              <Typography sx={imageCont}>
                                <Typography
                                  sx={displayFlex}
                                  style={{
                                    justifyContent: 'center',
                                    position: 'relative',
                                    alignItems: 'center',
                                    paddingRight: '10px',
                                  }}
                                >
                                  <CircularProgressWithProfile
                                    value={row?.buyerDetails?.profileActivity}
                                    profileImage={
                                      row?.buyerDetails?.user?.userProfile
                                    }
                                    name={
                                      row?.buyerDetails?.user?.userName.charAt(
                                        0
                                      ) +
                                      row?.buyerDetails?.user?.userSurName.charAt(
                                        0
                                      )
                                    }
                                  />
                                </Typography>

                                <Typography
                                  sx={(displayFlex, { cursor: 'pointer' })}
                                  aria-describedby={props.id}
                                >
                                  <Typography
                                    sx={{
                                      ...poppins400,
                                      fontSize: '12px',
                                      cursor: 'pointer',
                                      whiteSpace: 'nowrap',
                                    }}
                                  >
                                    {`${row?.buyerDetails?.user?.userName} ${row?.buyerDetails?.user?.userSurName}`}
                                  </Typography>
                                </Typography>

                                <KeyboardArrowDownIcon />
                              </Typography>
                            </Typography>
                          </TableCell>
                          <TableCell align="center">
                            <LinearProgressBarWithPercentage
                              value={row?.buyerDetails?.rediness}
                              rediness={row?.buyerDetails?.rediness}
                            />
                          </TableCell>

                          <TableCell align="center">
                            {
                              <OfferContainer
                                row={row}
                                data={row?.buyerOfferDetails?.offerPrice}
                              />
                            }
                          </TableCell>
                          <TableCell
                            sx={{ ...poppins400, fontSize: '14px' }}
                            align="center"
                          >
                            {row?.buyerDetails?.noOfOffers}
                          </TableCell>

                          <TableCell align="center">
                            <Typography
                              sx={displayFlex}
                              style={{
                                justifyContent: 'center',
                                position: 'relative',
                                alignItems: 'center',
                              }}
                            >
                              <CircularProgressWithLabel
                                value={row?.buyerDetails?.interestedAvg}
                                rating={row?.buyerDetails?.rating}
                              />
                              <CircularProgress
                                value={100}
                                variant="determinate"
                                sx={{
                                  position: 'absolute',
                                  color: '#C4C4C461',
                                  ...poppins500,
                                  fontSize: '14px',
                                }}
                                thickness={5}
                                size={45}
                              />
                            </Typography>
                          </TableCell>

                          <TableCell align="center">
                            {row?.buyerOfferDetails != '' ? (
                              <Typography
                                sx={{
                                  display: 'flex',
                                  textAlign: 'center',
                                  alignItems: 'center',
                                }}
                              >
                                <BadgeButton
                                  offerStatus={
                                    row?.buyerOfferDetails?.offerStatus
                                  }
                                  isnew={row?.buyerOfferDetails?.isNew}
                                />
                              </Typography>
                            ) : (
                              <Typography
                                sx={{
                                  display: 'flex',
                                  textAlign: 'center',
                                  alignItems: 'center',
                                }}
                              >
                                -
                              </Typography>
                            )}
                          </TableCell>
                          <TableCell align="center">
                            <Typography>
                              {isDisabled ? forwardedAt : '-'}
                            </Typography>
                          </TableCell>
                        </TableRow>
                      );
                    }
                  })
                ) : (
                  <TableRow>
                    <TableCell
                      colspan={12}
                      sx={{ textAlign: 'center', fontFamily: 'Poppins' }}
                    >
                      Buyer Not Available
                    </TableCell>
                  </TableRow>
                )}

                {emptyRows > 0 && (
                  <TableRow
                    style={{
                      height: 53 * emptyRows,
                    }}
                  >
                    <TableCell colSpan={6} />
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      </Box>
    </>
  );
}
